import { createContext, useContext } from 'react';

type CommandPaletteContextType = {
    openCommandPalette: () => void;
};

export const CommandPaletteContext = createContext<CommandPaletteContextType | null>(null);

export function useCommandPalette() {
    const context = useContext(CommandPaletteContext);

    if (!context) {
        throw new Error('useCommandPalette must be used within CommandPaletteContext.Provider');
    }

    return context;
}
